<template>
  <div class="Contact">
      <header style="background: rgb(247, 250, 252)" class="border-b">
          <container class="py-8 md:py-16">
            <div style="max-width: 720px" class="mx-auto">
              <ul class="breadcrumbs flex mb-4">
                <li><router-link to="/" class="text-awro-700" >{{$t('nav.home')}}</router-link></li>
                <li class="mx-1">/</li>
                <li><router-link to="/contact"  class="text-awro-700" active-class="router-active">{{$t('nav.contact')}}</router-link></li>
              </ul>
              <head-line :level="1" :size="1" :bold="true">{{$t('nav.contact')}}</head-line>
            </div>
          </container>
      </header>


      <container>
        <div style="max-width: 720px" class="mx-auto">
           <section class="my-12">
            <head-line :level="3" :size="3" :bold="true">
                <svg class="text-awro-600 fill-current" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 15V5C2 3.9 2.9 3 4 3H20C20.5304 3 21.0391 3.21071 21.4142 3.58579C21.7893 3.96086 22 4.46957 22 5V20C21.9972 20.1957 21.9371 20.3863 21.8271 20.5482C21.717 20.7101 21.5618 20.8361 21.3808 20.9106C21.1998 20.9852 21.001 21.0049 20.8088 20.9675C20.6167 20.93 20.4398 20.837 20.3 20.7L16.58 17H4C3.46957 17 2.96086 16.7893 2.58579 16.4142C2.21071 16.0391 2 15.5304 2 15ZM20 5H4V15H17C17.2638 15.0038 17.5154 15.1116 17.7 15.3L20 17.59V5Z"/>
                </svg>

                <span>
                    {{ $t('pages.contact.sendMessage')}}
                </span>
            </head-line>
            <form action="/contact" method="POST" class="mt-6">
                <div class="mb-4">
                  <label for="FullName" class="block text-black mb-1">{{ $t('form.field.fullname')}}</label>
                  <input type="text"
                  id="FullName"
                  name="FullName"
                  ref="FullName"
                  class="w-full border-2 px-4 py-2 rounded focus:outline-none"
                  :class="[{'border-red-600  form-group--error':$v.FullName.$error},{'focus:border-awro-600 hover:border-awro-600':!$v.FullName.$error}]"
                  v-model.trim="$v.FullName.$model"
                  />
                  <div class="error" v-if="$v.FullName.$error">
                         {{ $t('form.error.required')}}
                  </div>
                </div>
                <div class="mb-4">
                  <label for="Email" class="block text-black mb-1">{{ $t('form.field.email')}}</label>
                  <input
                  type="email"
                  id="Email"
                  name="Email"
                  ref="Email"
                  class="w-full border-2 px-4 py-2 rounded focus:outline-none"
                  :class="[{'border-red-600  form-group--error':$v.Email.$error},{'focus:border-awro-600 hover:border-awro-600':!$v.Email.$error}]"
                  v-model.trim="$v.Email.$model"
                  />
                  <div class="error" v-if="$v.Email.$error">
                      {{ $t('form.error.email')}}
                  </div>
                </div>
                <div class="mb-4">
                  <label for="Comment" class="block text-black mb-1">{{ $t('form.field.msg')}}</label>
                  <textarea
                  id="Comment"
                  name="Comment"
                  ref="Comment"
                  class="w-full border-2 px-4 py-2 rounded focus:outline-none"
                  rows="6"
                  v-model.trim="$v.Comment.$model"
                   :class="[{'border-red-600  form-group--error': $v.Comment.$error},{'focus:border-awro-600 hover:border-awro-600': !$v.Comment.$error}]"
                  ></textarea>
                  <div class="error" v-if="$v.Comment.$error">
                      {{ $t('form.error.msg') }}
                  </div>
                </div>

                <div v-if="serverError" class="error mb-4">
                    <div role="alert">
                        <div class="border border-red-400 rounded-b bg-red-100 px-4 py-3 text-red-700">
                            {{ $t('form.error.server') }}
                        </div>
                    </div>
                </div>

                <div>
                    <button
                    class="btn  px-5 py-2 rounded  focus:shadow-none select-none inline-flex items-center"
                    :disabled="loading"
                    :class="[{'text-gray-500 bg-gray-300 cursor-wait': loading, 'text-awro-100 bg-awro-600 hover:bg-awro-500 shadow ': !loading}]"
                    @click.prevent="sendMessage"
                    type="submit"
                    >
                    <svg v-if="loading" width="20" height="20" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#999">
                        <g fill="none" fill-rule="evenodd">
                            <g transform="translate(1 1)" stroke-width="2">
                                <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
                                <path d="M36 18c0-9.94-8.06-18-18-18">
                                    <animateTransform
                                        attributeName="transform"
                                        type="rotate"
                                        from="0 18 18"
                                        to="360 18 18"
                                        dur="1s"
                                        repeatCount="indefinite"/>
                                </path>
                            </g>
                        </g>
                    </svg>
                        <span v-if="!loading" :class="[{'ml-3': !isRtl && loading},{'mr-3': isRtl && loading}]">
                            {{$t('btn.send')}}
                        </span>
                    </button>
                </div>
            </form>
          </section>
          <hr>
          <section class="my-12 mb-16">
              <div class="md:flex justify-between mb-4">
                  <div class="inline-flex mb-2 md:mb-0">
                    <svg :class="[{'mr-2': !isRtl},{'ml-2': isRtl}]" class="text-awro-600 fill-current" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 5.62L10 7.62V18.38L14 16.38V5.62ZM16 5.62V16.38L20 18.38V7.62L16 5.62ZM8.00002 7.62L4.00002 5.62V16.38L8.00002 18.38V7.62ZM15 18.12L9.45002 20.9C9.31045 20.9703 9.15632 21.007 9.00002 21.007C8.84373 21.007 8.6896 20.9703 8.55002 20.9L2.55002 17.9C2.38359 17.8161 2.2439 17.6874 2.14672 17.5284C2.04954 17.3694 1.99873 17.1864 2.00002 17V4C1.99883 3.82869 2.04166 3.65994 2.12442 3.50994C2.20718 3.35994 2.32708 3.23372 2.47264 3.14337C2.61819 3.05303 2.78452 3.00159 2.95566 2.99399C3.12681 2.9864 3.29704 3.0229 3.45002 3.1L9.00002 5.89L14.55 3.12C14.6896 3.04966 14.8437 3.01302 15 3.01302C15.1563 3.01302 15.3104 3.04966 15.45 3.12L21.45 6.12C21.6134 6.20232 21.7511 6.3279 21.8481 6.48307C21.9451 6.63823 21.9976 6.81703 22 7V20C21.9995 20.1705 21.9554 20.338 21.872 20.4866C21.7885 20.6352 21.6684 20.7601 21.5231 20.8492C21.3779 20.9384 21.2122 20.989 21.0419 20.9961C20.8716 21.0032 20.7023 20.9667 20.55 20.89L15 18.12Z"/>
                    </svg>
                    <span>Empire World, Business Towers T4, Floor 13, No 1، Erbil</span>
                  </div>

                  <div class="inline-flex">
                   <svg :class="[{'mr-2': !isRtl},{'ml-2': isRtl}]" class="text-awro-600 fill-current" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.04 14.69L14.11 12.55C14.2176 12.3373 14.3976 12.1701 14.6177 12.0784C14.8377 11.9867 15.0832 11.9767 15.31 12.05L21.31 14.05C21.5105 14.1154 21.6852 14.2425 21.8091 14.4131C21.933 14.5837 21.9998 14.7891 22 15V20C22 20.5304 21.7893 21.0391 21.4142 21.4142C21.0391 21.7893 20.5304 22 20 22H18C13.7565 22 9.68687 20.3143 6.68629 17.3137C3.68571 14.3131 2 10.2435 2 6V4C2 2.9 2.9 2 4 2H9C9.20964 1.99946 9.41416 2.06482 9.58463 2.18685C9.7551 2.30887 9.88291 2.48138 9.95 2.68L11.95 8.68C12.0261 8.90811 12.0174 9.15598 11.9255 9.3782C11.8337 9.60043 11.6649 9.78212 11.45 9.89L9.3 10.96C10.189 12.5133 11.4767 13.801 13.03 14.69H13.04ZM8.28 4H4V6C4 9.71303 5.475 13.274 8.1005 15.8995C10.726 18.525 14.287 20 18 20H20V15.72L15.5 14.22L14.38 16.48C14.2638 16.7089 14.064 16.8843 13.822 16.9699C13.58 17.0555 13.3143 17.0448 13.08 16.94C10.4089 15.7359 8.26855 13.5991 7.06 10.93C6.95517 10.6957 6.94446 10.43 7.03008 10.188C7.11571 9.94604 7.29112 9.74624 7.52 9.63L9.78 8.49L8.28 4Z"/>
                  </svg>
                    <span dir="ltr">0750 5955775</span>
                  </div>

              </div>
              <div class="border-2 border-awro-500 rounded">
                <iframe class="rounded" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2707.311499299314!2d43.970012581592336!3d36.20172485356463!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40072393898ed059%3A0x29feb5c154145bfb!2sAwrosoft!5e0!3m2!1sen!2siq!4v1577607890806!5m2!1sen!2siq" width="100%" height="230" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
              </div>
          </section>
        </div>
        <hr>
      </container>
  <modal :title="$t('alert.contactSuccess.title')" :subtitle="$t('alert.contactSuccess.msg')" @close="closeModal" :show-modal="showSuccessModal"></modal>
</div>
</template>
<script>
/*eslint no-useless-escape: "off"*/

import Container from '@/components/Container';
import HeadLine from '@/components/theme/HeadLine'
import {mapGetters} from 'vuex'
import {validationMixin} from 'vuelidate'
import { required, minLength, maxLength,  email } from 'vuelidate/lib/validators'
import Modal from '@/components/Modal'
import Api from '@/api'

export default {
 name: 'Contact',
 mixins: [validationMixin],
  components: {
    Container,
    HeadLine,
    Modal
  },
  data() {
      return {
          loading: false,
          serverError: false,
          FullName: '',
          Email: '',
          Comment: '',
          Topic: '',
          Mobile: '',
          showSuccessModal: false
      }
  },
  validations: {
        FullName: {required},
        Email: {required, email},
        Comment: {
          required,
          minLength: minLength(25),
          maxLength: maxLength(255)
        }
  },
  computed: {
      ...mapGetters({
          isRtl: ['locale/IS_RTL']
      })
  },
  methods: {
      async sendMessage() {
        this.$v.$touch();

        if(this.$v.$anyError) {
          this.loading = false;
          
          var invalidFields = Object.keys(this.$v.$params)
                  .filter(fieldName => this.$v[fieldName].$invalid);
          this.$refs[invalidFields[0]].focus()
          return;
        }

        try {
          this.loading = true;
          this.serverError = false;
          let response = await Api.post('/contact/feedback/web', {
              FullName: this.FullName,
              Mobile: this.Mobile,
              Email: this.Mobile,
              Comment: this.Comment
          });
          if(response.status == 200) this.showSuccessModal = true;
        } catch {
          this.serverError = true;
        }

        this.loading = false;
        this.$v.$reset();
        
    },
    closeModal() {
      this.resetForm();
      this.$v.$reset();
      this.showSuccessModal = false;
    },
    resetForm() {
      this.loading = false;
      this.serverError = false;
      this.FullName = '';
      this.Email = '';
      this.Comment = '';
      this.showSuccessModal = false;
    }
  },
   metaInfo() {
    return {
      title: this.$i18n.t('awronore') + ' | ' + this.$i18n.t('pages.contact.title'),
      htmlAttrs: {
        amp: true,
        lang: this.$i18n.locale
      } 
    } 
  }
  
}

</script>


